import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9d0185a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "loading-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "换电有多香？模拟一把就知道", -1))
const _hoisted_3 = { class: "progress" }
const _hoisted_4 = { class: "progress-bar" }


import { showToast } from '@nio-fe/horo-h5'

// ios 16 以下弹窗提示升级 ios 系统

export default /*#__PURE__*/_defineComponent({
  props: {
    progress: null
  },
  setup(__props: any) {

const props = __props as {
  progress: number
}

try {
  const matchArr = navigator.userAgent.match(/iPhone OS (.*?) /)

  if (matchArr && matchArr[1]) {
    let version = +matchArr[1]

    if (matchArr[1].indexOf('_') !== -1) {
      version = +matchArr[1].split('_')[0]
    }
    if (version < 16) {
      setTimeout(() => {
        showToast({
          content: '请升级至iOS16以上，解锁完整使用体验',
          type: 'failure',
        })
      }, 1200)
    }
  }
} catch (ex) {
  console.error(ex)
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(props.progress || 0) + "%", 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "current",
        style: _normalizeStyle({ width: props.progress + '%' })
      }, null, 4)
    ])
  ]))
}
}

})